import { useQuery } from "@tanstack/react-query";
import { instance } from "api/apiBase";
import { VerificationNames } from "shared/types";

type CreditReportAlerts = {
  has_warnings: boolean;
  has_alerts_and_triggers_warnings: boolean;
  has_consumer_information_warnings: boolean;
  itin_detected: boolean;
  ssn_mismatched: boolean;
};

type VerificationsOverview = {
  [VerificationNames.CombinedIncome]?: {
    has_warnings: boolean;
  };
  [VerificationNames.CreditReport]?: CreditReportAlerts;
};

export const VERIFICATIONS_WITH_WARNINGS = [
  VerificationNames.CombinedIncome,
  VerificationNames.CreditReport
];

export const useVerificationsOverviewController = ({
  applicationId,
  applicantId
}: {
  applicationId: number;
  applicantId: number;
}) => {
  const verificationsOverviewMeta = useQuery({
    queryKey: ["VERIFICATIONS_OVERVIEW", applicationId, applicantId],
    queryFn: () =>
      instance
        .get<VerificationsOverview>(
          `/portal/v1/applications/${applicationId}/verifications_overview?applicant_id=${applicantId}`
        )
        .then(({ data }) => data),
    enabled: Boolean(applicationId) && Boolean(applicantId)
  });

  return { verificationsOverviewMeta };
};
